import {EventBus} from "./eventbus.js"

export function none() {
    EventBus.$emit('alert', {
        title: "An error?",
        message: "We could not retrieve that A-road, but it should be in our database. This might be an error? Try again shortly..."
    })
}

export function notFound() {
    EventBus.$emit('alert', {
        title: "Nonexistent A-Road ",
        message: "That A-road does not exist (as far as we know...)"
    })
}

export function someNotFound() {
    EventBus.$emit('alert', {
        title: "Some nonexistent A-roads",
        message: "Some of those A-roads do not exist (as far as we know...)"
    })
}

export function allNotFound() {
    EventBus.$emit('alert', {
        title: "Nonexistant A-roads",
        message: "All of those A-roads do not exist (as far as we know...)"
    })
}

export function apiError(message) {
    EventBus.$emit('alert', {
        title: 'API Error',
        message: message
    })
}

export function incorrectRange() {
    EventBus.$emit('alert', {
        title: "Invalid range",
        message: "Use only digits, commas and hyphens. EG 1,2,3,4-7,8,9-11"
    })
}

export function invalidARoad() {
    EventBus.$emit('alert', {
        title: "Invalid A-road!",
        message: "Try a number between 1 and 9999."
    })
}

